import React from 'react';
import styles from './NumberCheckbox.module.scss';

const NumberCheckbox = ({ number }) => {
  return <div className={styles.numberContainer}>{number}</div>;
};

export default NumberCheckbox;
